import React from 'react';
import ReactDOM from 'react-dom';
import Resume from './Resume';
import './index.css';

ReactDOM.render(
  <Resume />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js